/**
 * In a sense, this serves as a way to modify the marked for
 * deletion state. Since this will be used by other components to in the future,
 * we extracted the logic outside to its own hook.
 */
import { useEffect, useState } from "react"
export const useMultiDelete = () => {
    const [markedForDeletion, setMarkedForDeletion] = useState([])

    const handleInArray = (id) => {
        return markedForDeletion.includes(id);
    };

    const handleAddInArray = (id) => {
        const newArray = [...markedForDeletion, id];
        setMarkedForDeletion(newArray);
    };

    const handleRemoveFromArray = (id) => {
        const newArray = markedForDeletion.filter(item => item !== id);
        setMarkedForDeletion(newArray);
    };    

    const handleCheckboxChange = (id) => {
        if (handleInArray(id)) {
          handleRemoveFromArray(id);
        } else {
          handleAddInArray(id);
        }
    };

    const resetArray = () => {
        setMarkedForDeletion([]);
    }

    //For the multi delete functionality
    const handleAllCheckboxChange = (items) => {
        const listOfIds = items.map(item => item._id);

        const areAllMarked = listOfIds.every(id => markedForDeletion.includes(id));
    
        if (areAllMarked) {
            const newMarkedForDeletion = markedForDeletion.filter(id => !listOfIds.includes(id));
            setMarkedForDeletion(newMarkedForDeletion);
        } else {
            const newMarkedForDeletion = [...new Set([...markedForDeletion, ...listOfIds])];
            setMarkedForDeletion(newMarkedForDeletion);
        }
    }
    

    useEffect(()=>{
       // console.log(markedForDeletion)
    },[markedForDeletion])    

    return {markedForDeletion, handleAddInArray, handleRemoveFromArray, handleCheckboxChange, handleInArray, resetArray, handleAllCheckboxChange}
}